// extracted by mini-css-extract-plugin
export default {"iframe":"pdnhB_0HqqFs_fYxncxi"};